jQuery(document).ready(function ($) {
    'use strict'

    //mobile menu open
    $(".mobileToggle").on("click", function(){
        $("body").addClass("mobileMenuOpen");
    });

    //mobile menu close
    $(".mobileMenuClose").on("click", function(){
        $("body").removeClass("mobileMenuOpen");
    });

    //divided submenu elements to separated lists
    $('.divided-items').each(function (){
        var $li = $(this).children().children(),
            half = Math.floor($li.length/2);

        $li.filter(function(i){ return i < half; }).wrapAll('<ul>');
        $li.filter(function(i){ return i >= half; }).wrapAll('<ul>');
    });

    // submenu link dropdown toggle
    const $menuItems = $(".mobileMenu li.menu-item-has-children > a, .headerMenu .sub-menu ul li.menu-item-has-children > a");

    $menuItems.on("click", function(e){
        e.preventDefault();

        var $parent = $(this).closest("li");
        var parentIsActive = $parent.hasClass("active");

        if ($(window).width() > 1475) {
            $menuItems.each(function(index, item) {
                $(item).closest("li").removeClass("active");
            })
        }

        $parent.toggleClass("active", !parentIsActive);

        if ($(window).width() <= 1475) {
            $parent.find("> .sub-menu").slideToggle(!parentIsActive);
        }
    });

    // main menu link toggle
    const $mainNavItems = $(".headerMenu > li.menu-item-has-children > a");

    $mainNavItems.on("click", function(e) {
        e.preventDefault();

        var $parent = $(this).closest("li");
        var parentIsActive = $parent.hasClass("active");

        if ($(window).width() > 1475) {
            $mainNavItems.each(function(index, item) {
                $(item).closest("li").removeClass("active");
            })
        }

        $parent.toggleClass("active", !parentIsActive);
    })

    // close main menu submenus when clicked outside
    $(document).click(function(e) {
        var $target = $(e.target);

        if (!$target.closest(".headerMenu").length && $(".headerMenu > li > .sub-menu").is(":visible")) {
            $mainNavItems.each(function(index, item) {
                $(item).closest("li").removeClass("active");
            })
        }
    });

    //mobile search toggle
    $(".searchToggle").on("click", function(){
        $(".mobileSearchWrap .searchWrap").slideToggle();
    });

    //footer mobile search toggle
    $(".footerSearchToggle").on("click", function(){
        $(".footerMobileSearchWrap .searchWrap").slideToggle();
    });

    //homepage header swiper
    var swiper_index = 1;
    $('.homepageHeaderSlider.swiper').each(function(){
        var parent = $(this).closest(".homepageHeaderWrap");
        var slides_count = parent.find(".scrollbarLabel").length;
        var scroll_height = 100 / slides_count;
        var swiper_class = 'swiper-index-' + swiper_index;
        $(this).addClass(swiper_class);

        var swiper = new Swiper('.homepageHeaderSlider.swiper.' + swiper_class, {
            speed: 400,
            spaceBetween: 0,
            slidesPerView: 1,
            allowTouchMove: false,
            effect: 'fade',
            loop: false,
            autoplay: {
                delay: 4000,
            },
            on: {
                init: function() {
                    parent.find(".scrollbarWrap").addClass("scrollbarInit");
                }
            },
        });

        swiper.on('transitionStart', function () {
            var index = parseInt(swiper.realIndex);
            var scroll_position = scroll_height * parseInt(index);
            parent.find(".scrollbarBar").css("top", scroll_position + "%");
        });

        parent.find(".scrollbarBar").css("height", scroll_height + "%");

        parent.find(".scrollbarLabel").click(function(){
            var index = $(this).attr("data-index");
            swiper.slideTo(index);
        });

        swiper_index++;
    });

    //homepage sections slick
    $(".homepageSections").each(function(){
        var sections_count = $(this).attr("data-count");

        $(this).slick({
            infinite: true,
            slidesToShow: sections_count,
            arrows: false,
            autoplay: false,
            touchThreshold: 10,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: sections_count - 1,
                        autoplay: false,
                    }
                }
            ]
        });
    });

    //solutions wheel swiper
    var swiper_index = 1;
    $('.solutionsWheelSlider.swiper').each(function(){
        var swiper_class = 'swiper-index-' + swiper_index;
        var parent = $(this).closest(".solutionsWheelWrap");
        var slides_count = parent.find(".scrollbarLabel").length;
        var scroll_height = 100 / slides_count;
        $(this).addClass(swiper_class);

        var swiper = new Swiper('.solutionsWheelSlider.swiper.' + swiper_class, {
            speed: 400,
            spaceBetween: 0,
            slidesPerView: 1,
            allowTouchMove: false,
            loop: false,
            autoHeight: true,
            on: {
                init: function() {
                    parent.find(".scrollbarWrap").addClass("scrollbarInit");
                }
            },
        });

        //on resize go to first slide
        $(window).on("resize", function() {
            if ($(window).width() < 1340) {
                var index = 0;
                var scroll_position = scroll_height * parseInt(index);
                parent.find(".scrollbarBar").css("top", scroll_position + "%");
                swiper.slideTo(index);
            }
        });

        parent.find(".scrollbarBar").css("height", scroll_height + "%");

        parent.find(".scrollbarLabel").click(function(){
            var index = $(this).attr("data-index");
            var scroll_position = scroll_height * parseInt(index);
            parent.find(".scrollbarBar").css("top", scroll_position + "%");
            swiper.slideTo(index);
            circleAnimation(parent, index);
        });

        swiper_index++;
    });

    //solutions wheel mobile slick
    $(".mobileLabels").each(function(){

        $(this).slick({
            infinite: true,
            slidesToShow: 1,
            arrows: false,
            dots: true,
            autoplay: false,
            touchThreshold: 10
        });
    });

    //news room tabs
    $(".roomTab").on("click", function(){
        var tab = $(this);
        var news_room = tab.closest(".newsRoomWrap");
        var id = tab.attr("data-marco");

        news_room.find("li.active").removeClass("active");
        tab.closest("li").addClass("active");

        news_room.find(".roomTabContent").each(function(){
            if($(this).attr("data-polo") == id){
                $(this).addClass("active");
            }
            else {
                $(this).removeClass("active");
            }
        });
    })

    //case studies spotlight swiper
    var swiper_index = 1;
    $('.spotlightSwiper.swiper').each(function(){
        var swiper_class = 'swiper-index-' + swiper_index;
        var pagination_class = 'pagination-index-' + swiper_index;
        var parent = $(this).closest(".caseStudiesSpotlightWrap");
        var pagination = parent.find('.swiper-pagination');
        pagination.addClass(pagination_class);
        $(this).addClass(swiper_class);

        var swiper = new Swiper('.spotlightSwiper.swiper.' + swiper_class, {
            speed: 400,
            spaceBetween: 0,
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.' + pagination_class,
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                320: {
                    allowTouchMove: true
                },
                950: {
                    allowTouchMove: false
                }
            }
        });

        parent.find(".spotlightNext").click(function(){
            swiper.slideNext();
        });

        swiper.on('transitionEnd', function () {
            var index = parseInt(swiper.realIndex) + 1;
            parent.find(".swiper-slide.active").removeClass("active");
            parent.find(".swiper-slide.slide-" + index).addClass("active");
        });

        swiper_index++;
    });

    //podcasts swiper
    $('.podcastsSwiper').each(function(){
        var slides_count = $(this).attr("data-count");

        if(slides_count == 1){
            slides_count = 2;
        }

        $(this).slick({
            infinite: true,
            arrows: false,
            slidesToShow: slides_count - 1,
            autoplay: false,
            touchThreshold: 15,
            variableWidth: true
        });
    });

    //link swiper
    $('.linkSwiper').each(function(){
        var slides_count = $(this).attr("data-count");
        var parent = $(this).closest(".cptSwiperWrap");

        var link_swiper = $(this).slick({
            infinite: true,
            arrows: false,
            slidesToShow: slides_count - 1,
            autoplay: false,
            touchThreshold: 15,
            variableWidth: true,
            swipeToSlide: true
        });

        parent.find(".cptPrev").click(function(){
            link_swiper.slick("slickPrev");
        });

        parent.find(".cptNext").click(function(){
            link_swiper.slick("slickNext");
        });
    });

    //timeline swiper
    $(".timelineSlide").on("click", function(){
        var parent = $(this).closest(".timelineWrap");
        var swiper = parent.find(".timelineSwiper");
        var index = $(this).attr("data-index");
        var change = true;
        var slide = true;
        var offset = 170;

        if(index == 0){
            slide = false;
        }

        if($(this).hasClass("active")){
            change = false;
        }

        if(change){
            if(slide) {
                changeYear(parent, index);
            }
            else {
                changeYear(parent, index, false);
            }
        }
    });

    $(".timelinePrev").on("click", function(){
        var parent = $(this).closest(".timelineWrap");
        var swiper = parent.find(".timelineSwiper");
        var current_index = swiper.attr("data-current");
        var offset = 170;

        if(current_index != 0){
            changeYear(parent, parseInt(current_index) - 1);
        }
    });

    $(".timelineNext").on("click", function(){
        var parent = $(this).closest(".timelineWrap");
        var swiper = parent.find(".timelineSwiper");
        var current_index = swiper.attr("data-current");
        var max = swiper.attr("data-max");

        if(current_index != (max - 1)){
            changeYear(parent, parseInt(current_index) + 1);
        }
    });

    $(".timelineBodyInner.active").each(function(){
        initTimelineSection($(this));
    });

    $(".timelineBodyInner .scrollbarLabel").on("click", function(){
        changeTimelineSection($(this));
    });

    function initTimelineSection(section){
        var slides_count = section.find(".scrollbarLabel").length;
        var scroll_height = 100 / slides_count;
        section.find(".scrollbarBar").css("height", scroll_height + "%");
    }

    function changeTimelineSection(section){
        var parent = section.closest(".timelineBodyInner");
        var index = section.attr("data-index");
        var slides_count = parent.find(".scrollbarLabel").length;
        var scroll_height = 100 / slides_count;
        var scroll_position = scroll_height * (parseInt(index) - 1);

        parent.find(".milestoneWrap.active").removeClass("active");
        parent.find(".milestoneWrap[data-index='" + index + "']").addClass("active");

        parent.find(".scrollbarBar").css("top", scroll_position + "%");
    }

    function changeYear(parent, index, slide = true){
        var offset = 170;
        var swiper = parent.find(".timelineSwiper");

        parent.find(".timelineSlide.active").removeClass("active");
        parent.find(".timelineSlide[data-index='" + index + "']").addClass("active");

        parent.find(".timelineBodyInner.active").removeClass("active");

        var active_section = parent.find(".timelineBodyInner[data-index='" + index + "']")
        active_section.addClass("active");

        initTimelineSection(active_section);

        if(slide){
            swiper.css("margin-left", "-" + (offset * ((index) - 1)) + "px").attr("data-current", index);
        }
    }

    //end timeline swiper

    //custom post type swiper
    var swiper_index = 1;
    $('.cptSwiper.swiper').each(function(){
        var swiper_class = 'swiper-index-' + swiper_index;
        var parent = $(this).closest(".cptSwiperWrap");
        $(this).addClass(swiper_class);

        var swiper = new Swiper('.cptSwiper.swiper.' + swiper_class, {
            speed: 400,
            spaceBetween: 0,
            slidesPerView: 1,
            loop: true
        });

        parent.find(".cptPrev").click(function(){
            swiper.slidePrev();
        });

        parent.find(".cptNext").click(function(){
            swiper.slideNext();
        });

        swiper_index++;
    });

    //viewport animations
    viewportChecks();
    $(window).on("load scroll", function() {
        viewportChecks();
    });

    //classes to check
    function viewportChecks() {
        checkAllInViewport(".homepageHeader");
        checkAllInViewport(".pageHeader");
        checkAllInViewport(".infoSection1");
        checkAllInViewport(".infoSection2");
        checkAllInViewport(".infoSection3");
        checkAllInViewport(".stats");
        checkAllInViewport(".solutionsWheel");
        checkAllInViewport(".newsRoom");
        checkAllInViewport(".blogWrapper");
        checkAllInViewport(".locationsMapWrap");
        checkAllInViewport(".videosWrap");
        checkAllInViewport(".podcastsWrap");
        checkAllInViewport(".enquiryFormWrap");
        checkAllInViewport(".locationsListWrap");
        checkAllInViewport(".contentGridWrap");
        checkAllInViewport(".ctaSectionWrap");
        checkAllInViewport(".cptSwiperWrap");
        checkAllInViewport(".productHeaderWrap");
        checkAllInViewport(".productBodyWrap");
        checkAllInViewport(".caseStudiesHeaderWrap");
        checkAllInViewport(".locationsInfoWrap");
        checkAllInViewport(".linkSwiperWrap");
        checkAllInViewport(".timelineWrap");
        checkAllInViewport(".textImageGridWrap");
        checkCaseStudiesSpotlightInViewport();
        checkWheelSingleInViewport();
    }

    //check for multiple of the same block
    function checkAllInViewport(section) {
        $(section).each(function(){
            if(!$(this).hasClass("start")){
                var info_section_visible = checkInViewport($(this));

                if(info_section_visible){
                    $(this).addClass("start");
                }
            }
        });
    }

    //check block is in viewport
    function checkInViewport(section) {
        if($(parent).hasClass("start") == false){
            var elementTop = $(section).offset().top;
            var elementBottom = elementTop + $(section).outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            if(elementBottom > viewportTop && elementTop < viewportBottom) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    //animate circle
    function circleAnimation(parent, index){
        parent.find(".swiper-slide").each(function(){
            var slide_index = $(this).attr("data-index");
            var circle = $(this).find(".percentageCircle");

            if(slide_index == index){
                circle.addClass("active");
                circle.find(".circle").each(function(){
                    var percentage = $(this).attr("data-percentage");
                    $(this).css("transform", "rotate(" + percentage + "deg)");
                })
            }
            else {
                circle.removeClass("active");
                circle.find(".circle").each(function(){
                    var percentage = $(this).attr("data-default");
                    $(this).css("transform", "rotate(" + percentage + "deg)");
                })
            }
        });
    }

    //check case studies spotlight in viewport and add active to first slide
    function checkCaseStudiesSpotlightInViewport(){
        $(".caseStudiesSpotlight").each(function(){
            if(!$(this).hasClass("start")){
                var case_studies_visible = checkInViewport($(this));

                if(case_studies_visible){
                    $(this).addClass("start").find(".slide-1").addClass("active");
                }
            }
        });
    }

    //check wheel single in viewport and replicate slide js from above
    function checkWheelSingleInViewport(){
        $(".wheelSingle").each(function(){
            if(!$(this).hasClass("wheel_start")){
                var wheel_single_visible = checkInViewport($(this));

                if(wheel_single_visible){
                    $(this).addClass("wheel_start").find(".swiper-slide").addClass("swiper-slide-active");
                    circleAnimation($(this), 1);
                }
            }
        });
    }


    function modalWindow() {

        const modalContent = modal.querySelector(".modalVideoWrapper");
        const openBtn = document.getElementById("js-openModal");
        const closeBtn = modal.querySelector("#js-closeModal");
        const video = modal.querySelector("#modalVideo");

        openBtn.addEventListener('click', (e) => {
            e.preventDefault();
            modal.style.display = "flex";
                modalContent.appendChild(video);
        });

        closeBtn.addEventListener('click', () => {
            modal.style.display = "none";
            document.getElementById("modalVideo").remove();
        });

        window.addEventListener('click', (event) => {
            if (event.target === modal) {
                modal.style.display = "none";
                document.getElementById("modalVideo").remove();
            }
        });
    }

    const modal = document.getElementById("modalWindow");
    if (modal) modalWindow();

    if ($('.js_contactForm').length) {
        submitForm('.js_contactForm');
    }
    
    //Checkboxes
    let checkboxes = document.querySelector(".checkbox-boxes");

    if( checkboxes != null ) {
        let inputs = checkboxes.querySelectorAll('.wpcf7-list-item');
        
        inputs.forEach((input) => {
            input.addEventListener("click", function(e) {
                console.log("click");
                this.classList.toggle("checked");
            })
        })
    }

}); // document ready
